import React, { useState } from "react";
import { useQuery, useQueryClient } from "react-query";
import TableOrganism from "../../organisms/Table/TableOrganism";
import { createHeaderRow } from "../../utilities/CreateHeaderRow";
import { createFieldProcessorRows } from "./FieldProcessorTableData";
import useApiService from "../../utilities/useApiService";
import { useLoaderDispatch } from "../../context/LoaderContext";
import { startLoading, stopLoading } from "../../context/actions/loaderActions";

const FieldProcessorTable = () => {
  const { getMethod } = useApiService();
  const loaderDispatch = useLoaderDispatch();
  const queryClient = useQueryClient();
  const [loadingMap, setLoadingMap] = useState<Record<number, boolean>>({});

  const fetchUsers = async () => {
    startLoading(loaderDispatch);

    const response = await getMethod("/admin/users");

    stopLoading(loaderDispatch);

    return response.data.filter((user: any) => user.role === "FieldProcessor");
  };

  const { data = [] } = useQuery("fieldProcessors", fetchUsers);

  const rows = createFieldProcessorRows(
    data,
    queryClient,
    loadingMap,
    setLoadingMap,
  );

  const headers = ["Username", "Email", "Active"];

  return <TableOrganism rows={rows} header={createHeaderRow(headers)} />;
};

export default FieldProcessorTable;
